import permissionMessages from
  'ringcentral-integration/modules/RolesAndPermissions/permissionsMessages';

export default {
  [permissionMessages.invalidTier]: 'Esta edición no admite la integración con {application}. Llame a su representante de cuentas para actualizar su edición de {brand}.',
};
